import store from '../../vuex/store'
import { isUserMoowleVerified, postUser, updateEntireUser, getUserByUid } from '../repositories/userRepository.js'
import { captureMessage, captureException } from '@/utils/reporting/reportingService.js'

export const getCurrentUser= async (uid)=>{
  try{
    if(store.getters.user.uid) return store.getters.user 
    const user = await getUserByUid(uid)
    if(!user) throw new Error("Cannot retrieve user data"); 
    else return user
  }catch(ex){
    return false
  }
}

export const getUser = async (uid) =>{
  try{
    const user = await getUserByUid(uid)
    if(!user) throw new Error("Cannot retrieve user data"); 
    else return user
  }catch(ex){
    return false
  }
}

export const createUser = async (createUserCommand) => {
  try{
    captureMessage("attempt... userService.createUser() > email: " + createUserCommand.email)
    const newUser = await postUser(createUserCommand)
    if(!newUser) throw new Error("New user created is not valid"); 
    captureMessage('success... userService.createUser() > email: ' + newUser.email)
    return newUser
  }catch(ex){
    captureException('userService.createUser() > err: ', ex) // log error, and...
    throw ex  // ...pass this error up (to decorator)
  }
}

export const updateUser = async (uid, userObj) => {
  try{
    const updateResponse = await updateEntireUser({uid, userObj})
    if(!updateResponse) throw new Error("User update failed"); 
    return updateResponse
  }catch(ex){
    captureException('userService.updateUser() > err: ', ex)
  }
}

export const getCurrentChatUserIdentity = () => {
  return new Promise(function (resolve, reject) {
    store.getters.currentChatUserId?resolve(store.getters.currentChatUserId): reject("chat user not set");
  })
}

// user = db user (not firebase user)
// TODO: This needs to execute first before the app loads any more resources
export const initiateUser = async ({domainUser, authUser}) => {
  try {
    initUser({domainUser, authUser})
    await initUserAccounts(domainUser)
    if (domainUser.chatEnabled) {
      store.dispatch('initiateChat', domainUser.uid);
    }
  }
  catch (error) {
    console.error(error);
  }
  // else this will be handled in the main.js chatEnabled watcher
}

let initUser = ({domainUser, authUser}) => {
  store.commit("SET_IS_USER_VERIFIED", isUserMoowleVerified(domainUser));
  store.commit("SET_IS_USER_EMAIL_VERIFIED", authUser.emailVerified);
  store.commit("SET_USER_DATA", domainUser)
  store.commit("IS_LOADING_USER", false)
  store.dispatch("decideToAskNpsOfUser", { user: domainUser })
  store.dispatch("editUserViewRole", sessionStorage.getItem('user_view_role'))
  sessionStorage.setItem('user_just_registered', false) // this tells firebase auth listener to get user from our system since the user is initiated and now new anymore
  if(domainUser.signedUpAs) store.dispatch("editUserViewRole", domainUser.signedUpAs)
}

let initUserAccounts = async (user) =>{
  var accountIds = []
  if(user.accountIds){
    accountIds = user.accountIds
    store.commit("SET_ACCOUNT_IDS_IN_MEM", { userUid: user.uid, accountIds:accountIds })
    store.commit("SET_CONNECTED_ACCOUNT_IDS", accountIds)
    store.commit("SET_ACCOUNT_INITIATED", true)
  }else{
    accountIds = await store.dispatch("retrieveUserAccountIds", { userUid: user.uid })
    store.commit("SET_ACCOUNT_INITIATED", true)
  }

  if(accountIds && accountIds.length > 0){
    // TODO: change default from 0 index to what user has selected as current account.
    store.dispatch("retrieveAccountPersons", { accountId: accountIds[0] })
    
    let account = await store.dispatch("getAccount", accountIds[0])
    // We cannot allow a situation where account doesn't have contact email set
    if(account.accountId && (!account.contactDetails || !account.contactDetails.contactEmail)) substitudeAccountContactsWithUserContacts(account.accountId, user)
  }else{
    captureException("no accountIds found for user w/ uid:" + user.uid)
    // Todo: notify error to user.
  }
}

// This is partly a backward compatibility function where account didn't have contac details, 
//  also acts as a fallback if, for some reason, account contacts have been erased.
let substitudeAccountContactsWithUserContacts = (accountId, user) =>{ 
  store.dispatch("updateAccount", {
    accountId: accountId,
    updates: { 
      contactDetails: {
        contactEmail: user.email,
        contactPhone: user.phone
      }
    }
  });
}


// WEBPACK FOOTER //
// ./src/users/services/userService.js